/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Spell_CheckInputs */

const en_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell Check`)
};

const fr_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification orthographique`)
};

const de_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfung`)
};

const it_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo ortografico`)
};

const ru_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка орфографии`)
};

const es_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrector ortográfico`)
};

const zh_cn2_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写检查`)
};

const ja_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペルチェック`)
};

const hi_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी की जाँच`)
};

const pt_pt2_options_quicktools_spell_check = /** @type {(inputs: Options_Quicktools_Spell_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção ortográfica`)
};

/**
* | output |
* | --- |
* | "Spell Check" |
*
* @param {Options_Quicktools_Spell_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_spell_check = /** @type {((inputs?: Options_Quicktools_Spell_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Spell_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_spell_check(inputs)
	if (locale === "de") return de_options_quicktools_spell_check(inputs)
	if (locale === "it") return it_options_quicktools_spell_check(inputs)
	if (locale === "ru") return ru_options_quicktools_spell_check(inputs)
	if (locale === "es") return es_options_quicktools_spell_check(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_spell_check(inputs)
	if (locale === "ja") return ja_options_quicktools_spell_check(inputs)
	if (locale === "hi") return hi_options_quicktools_spell_check(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_spell_check(inputs)
	return en_options_quicktools_spell_check(inputs)
});